import type { IStyle } from 'fela';

import { shiftColor } from '../utils/shift-color';

import type { Theme } from '../types';

export const trail: IStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '10px',
  marginBottom: '24px',
  fontSize: '0.9rem'
};

// The brand green is a pale pill colour, unreadable as text on a light page, so
// darken it. This shift measures 5.24:1 against the page background, comfortably
// past WCAG AA for body text.
export const link: (theme?: Theme) => IStyle = (theme) => {
  const color = shiftColor(theme?.button?.style?.backgroundColor ?? '#cfff92', -140);

  // The global reset declares `a, a:visited, a:hover, a:active { color: inherit }`.
  // `a:visited` outranks a single class, so a crumb whose target the reader has
  // already opened would lose its colour. Restating it per state wins that.
  return {
    color,
    textDecoration: 'none',
    ':visited': { color },
    ':hover': { color, textDecoration: 'underline' },
    ':active': { color }
  };
};

export const current: IStyle = {
  opacity: 0.75
};

export const separator: IStyle = {
  opacity: 0.4
};
